import React, { useEffect, useState } from 'react'
import InterviewQuestions from './screens/InterviewQuestions'
import Audio from './screens/Audio'
import End from './screens/End'
import Feedback from '../prep/Screens/Feedback'
import PageStatus from '@/component/PageStatus'
import PrepActions from '@/redux/prep'
import { Helmet } from 'react-helmet'

const Questions = () => {
  const [index, setIndex] = useState(1)
  const [loading, setLoading] = useState(false)
  const [sessionId, setSessionId] = useState('')
  const [questions, setQuestions] = useState({
    category: [],
    question_bank: []
  })
  const [selcQues, setSelcQues] = useState(null)
  const [audio, setAudio] = useState(null)
  const [ansTrans, setAnsTrans] = useState('')
  const [feedback, setFeedback] = useState('')

  let session_type = 'questionbank_flow'

  useEffect(() => {
    fetchQuestionBank()
  }, [])

  const fetchQuestionBank = async () => {
    setLoading(true)
    const res = await PrepActions.fetchQuestionBank()
    setQuestions(res.data)
    // console.log('first')
    setLoading(false)
  }

  const sendAudio = async () => {
    setLoading(true)
    // console.log(audio)
    if (audio) {
      const res = await PrepActions.sendQuesAudio(selcQues, audio)
      // updateAnsTrans(quesNum, res.transcription)
      // updateFeedback(quesNum, res.feedbackk)
      setSessionId(res.data.session_id)
      setAnsTrans(res.data.transcription)
      setFeedback(res.data.feedback)
      setIndex(3)
    }
    setLoading(false)
  }

  const handleTryAgain = () => {
    setLoading(true)
    setSelcQues(null)
    setAudio(null)
    setAnsTrans('')
    setFeedback('')
    setIndex(1)
    setLoading(false)
  }

  if (loading) return <PageStatus type="loading" />

  return (
    <>
      <Helmet>
        <title>Ai-Interview Preparations</title>
        <meta
          name="description"
          content="Explore ApplyIn's extensive question bank. From common to niche queries, prepare for any interview scenario. Power up your skills with AI insights from ChatGPT."
        />
      </Helmet>
      {index == 1 && <InterviewQuestions setIndex={setIndex} questions={questions} setSelcQues={setSelcQues} />}
      {index == 2 && (
        <Audio setIndex={setIndex} selcQues={selcQues} audio={audio} setAudio={setAudio} sendAudio={sendAudio} />
      )}
      {index == 3 && (
        <End
          setIndex={setIndex}
          selcQues={selcQues}
          audio={audio}
          ansTrans={ansTrans}
          feedback={feedback}
          loading={true}
          handleTryAgain={handleTryAgain}
        />
      )}
      {index == 4 && <Feedback session_type={session_type} sessionId={sessionId} setLoading={setLoading} />}
    </>
  )
}
export default Questions
